import { request } from './core.api';

export interface CalendarItemDto {
  id: string;
  sourceType: 'Reminder' | 'DocumentExpiry' | 'AgreementEnd' | 'TimelineEvent';
  date: string;
  title: string;
  detailType?: string;
  propertyId?: string;
  propertyAddress?: string;
  tenantId?: string;
  tenantName?: string;
  description?: string;
  targetPath: string;
}

export interface CalendarDto {
  startDate: string;
  endDate: string;
  summary: {
    reminderCount: number;
    documentExpiryCount: number;
    agreementEndCount: number;
    eventCount: number;
    totalCount: number;
  };
  items: CalendarItemDto[];
}

export const calendarApi = {
  getRange: (start: string, end: string) => request<CalendarDto>(`/calendar?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}`),
};
